module.exports = __webpack_public_path__ + "static/media/pot.925f936f.svg";